import type {
  DTOBulkInviteRequest,
  DTOBulkInviteResponse,
  DTOInviteFromSwipeAzarRequest,
  DTOInviteFromSwipeAzarResponse,
} from 'src/apis/dto/DTOInviteFromSwipeAzar';

import type { APIClientType } from '.';

export interface InviteFromSwipeAzarServiceType {
  fetchRecommendCards: (
    data: DTOInviteFromSwipeAzarRequest
  ) => Promise<DTOInviteFromSwipeAzarResponse>;
  bulkInvite: (data: DTOBulkInviteRequest) => Promise<DTOBulkInviteResponse>;
}

export class InviteFromSwipeAzarService implements InviteFromSwipeAzarServiceType {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  public fetchRecommendCards = async (data: DTOInviteFromSwipeAzarRequest) => {
    return this.client.call<DTOInviteFromSwipeAzarResponse, DTOInviteFromSwipeAzarRequest>({
      method: 'post',
      path: '/lounge/v2/cards/recommend/invite-from-swipe-azar',
      data,
    });
  };

  public bulkInvite = async (data: DTOBulkInviteRequest) => {
    return this.client.call<DTOBulkInviteResponse, DTOBulkInviteRequest>({
      method: 'post',
      path: '/api/v1/match/invites/bulk',
      data,
    });
  };
}
